import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const WelcomeText = styled.p`
  font-size: 0.975rem;
  text-align: center;
  padding-top: ${rhythm(2)};
  max-width: 100%;
`;

export default WelcomeText;
